import PropTypes from 'prop-types';
import { useState } from 'react';
import { ROOM_SETTINGS_PAGES } from '../../../../../constants/roomSettings';
import { useRoomSettings } from '../../../../../hooks/useRoomSettings';
import Header from './Header';
import SideBar from './SideBar';
import SecurityPage from './SecurityPage';
import PermissionsPage from './PermissionsPage';
import NotificationsPage from './NotificationsPage';
import DetailsPage from './DetailsPage';
import './Modal.css';

const Modal = ({
  roomId,
  onClose = () => {},
}) => {
  const {
    roomName,
    roomTopic,
    roomVersion,
    canConfigure,
    canEditName,
    canEditTopic,
    userPowerLevel,
    isDM,
    isEncrypted,
    joinRule,
    historyVisibility,
    permissionLevels,
    updateJoinRule,
    updateHistoryVisibility,
    updatePermissionLevel,
    updateRoomName,
    updateRoomTopic,
  } = useRoomSettings(roomId);

  // Start with notifications page if user doesn't have configure permissions
  const initialPage = canConfigure ? ROOM_SETTINGS_PAGES.SECURITY : ROOM_SETTINGS_PAGES.NOTIFICATIONS;
  const [currentPage, setCurrentPage] = useState(initialPage);

  // Render current page content
  const renderPageContent = () => {
    switch (currentPage) {
    case ROOM_SETTINGS_PAGES.SECURITY:
      return (
        <SecurityPage
          isDM={isDM}
          isEncrypted={isEncrypted}
          joinRule={joinRule}
          historyVisibility={historyVisibility}
          onJoinRuleChange={updateJoinRule}
          onHistoryVisibilityChange={updateHistoryVisibility}
          canConfigure={canConfigure}
          userPowerLevel={userPowerLevel}
        />
      );
    case ROOM_SETTINGS_PAGES.PERMISSIONS:
      return (
        <PermissionsPage
          permissionLevels={permissionLevels}
          onPermissionChange={updatePermissionLevel}
          canConfigure={canConfigure}
        />
      );
    case ROOM_SETTINGS_PAGES.NOTIFICATIONS:
      return <NotificationsPage roomId={roomId} />;
    case ROOM_SETTINGS_PAGES.DETAILS:
      return (
        <DetailsPage
          roomId={roomId}
          roomName={roomName}
          roomTopic={roomTopic}
          roomVersion={roomVersion}
          canEditName={canEditName}
          canEditTopic={canEditTopic}
          onUpdateName={updateRoomName}
          onUpdateTopic={updateRoomTopic}
        />
      );
    default:
      return null;
    }
  };

  return (
    <div className="room-settings-modal">
      <div className="room-settings-modal-header">
        <Header
          title={roomName}
          onClose={onClose}
        />
      </div>
      <div className="room-settings-modal-body">
        <SideBar
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          canConfigure={canConfigure}
          userPowerLevel={userPowerLevel}
        />
        <div className="room-settings-modal-content">
          {renderPageContent()}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  roomId: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

export default Modal;
